import { useQueryClient } from '@tanstack/react-query'

import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateEvent from '@/modules/events/api/hooks/useMutationUpdateEvent'
import { EventsQueryKeys } from '@/modules/events/keys'

import type { GetEventDataResponse } from '@/modules/events/type'

interface IsActiveEventProps {
	row: GetEventDataResponse
}

export function IsActiveEvent({ row }: IsActiveEventProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateEvent } = useMutationUpdateEvent()

	const handleMutate = async (value: boolean) => {
		await updateEvent({
			id: row.id,
			payload: {
				isActive: value,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [EventsQueryKeys.getEvents],
		})
	}

	return <SetIsActive defaultChecked={row.isActive} onMutate={handleMutate} />
}
